import { render, staticRenderFns } from "./SideOrders.vue?vue&type=template&id=3542bc68&scoped=true&"
import script from "./SideOrders.vue?vue&type=script&lang=js&"
export * from "./SideOrders.vue?vue&type=script&lang=js&"
import style0 from "./SideOrders.vue?vue&type=style&index=0&id=3542bc68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3542bc68",
  null
  
)

export default component.exports